(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairSeminarsController', PhysicalFairSeminarsController)

        PhysicalFairSeminarsController.$inject = ['$uibModal', '$scope','SellerService' ,'ExpoService', 'VirtualFairService', 'AclService','CountriesNewService', 'TimezonesService','$http', 'API_BASE', '$state','toastr','$stateParams'];


    function PhysicalFairSeminarsController( $uibModal, $scope, SellerService, ExpoService, VirtualFairService, AclService, CountriesNewService, TimezonesService, $http, API_BASE, $state, toastr, $stateParams) {
        var vm = this;

        vm.seminars              = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.expo                  = '';
        vm.expoSelected          = '';

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'Yes', value:1};
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.deleteSeminar         = deleteSeminar;
        vm.countResult           = 0;
        vm.registersInEventSelected = {name:'No', id:0};
        vm.registersInEventList = [{id:'all', name:'All'},{id:1, name:'Yes'},{id:0,name:'No'}];


        function activate() {
            if ($stateParams.hasOwnProperty('msg') && $stateParams.msg) {
                if ($stateParams.error) {
                    toastr.error(`${$stateParams.msg}`);
                } else {
                    toastr.success(`${$stateParams.msg}`);
                }
                
            }
            vm.selectExpo();
            vm.getByFilter()
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function deleteSeminar(seminar, index) {
            console.log('deleteSeminar');

            alertify
                .confirm(`Do you really want to delete this <strong>${seminar.name + ': ' + seminar.city_name}</strong>?`)
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Delete Seminar')
                .set('onok', function (){
                    ExpoService.deleteSeminar(seminar.id)
                        .then(function (response) {
                            vm.seminars.splice(index, 1);
                            alertify.success('Seminar successfull deleted!');
                        });
                })
                .show();
        }

        function getByFilter() {
            vm.query = {
                expo_id: vm.expoSelected.id
            };
            ExpoService.getByFilterSeminars(vm.query).then(function(response){
                console.log(vm.seminars)
                vm.seminars = response.data;
                vm.queryFlag       = true;
                vm.countResult     = Object.keys(response.data).length;
            }).catch(function(err) {

            });
        }

        function removeSeminar(index){
            vm.delete_seminars.push({id: vm.seminars[index].id});
            vm.seminars.splice(index, 1);
        }

        activate();
    }

})();